import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const footerLinks = [
    {
      title: '内容分类',
      links: [
        { label: '电影', href: '/category/movie' },
        { label: '电视剧', href: '/category/tv' },
        { label: '动漫番剧', href: '/category/anime' },
        { label: '综艺节目', href: '/category/variety' },
        { label: '韩国电影', href: '/category/korean' },
        { label: '美国大片', href: '/category/hollywood' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', href: '/about' },
        { label: '联系方式', href: '/about' },
        { label: '用户反馈', href: '/about' },
        { label: '加入我们', href: '/about' },
      ],
    },
    {
      title: '热门推荐',
      links: [
        { label: '狂飙', href: '/article/kuangbiao' },
        { label: '满江红', href: '/article/manjianghong' },
        { label: '流浪地球2', href: '/article/liulangdiqiu2' },
        { label: '鬼灭之刃', href: '/article/guimie' },
      ],
    },
    {
      title: '友情链接',
      links: [
        { label: '香蕉视频', href: '#', target: '_blank', rel: 'nofollow' },
        { label: '糖心视频', href: '#', target: '_blank', rel: 'nofollow' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <a
              href="/"
              className="flex items-center gap-2 mb-4 cursor-pointer"
              onClick={(e) => { e.preventDefault(); navigate('/'); }}
            >
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
              </span>
              <span className="text-lg font-heading font-semibold text-foreground-950 whitespace-nowrap">
                蘑菇视频
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed">
              蘑菇视频提供香蕉视频、糖心视频等中外影视资源点播，涵盖韩国电影、美国大片、最新电视剧、热播剧集、动漫番剧，高清免费在线观看。
            </p>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 whitespace-nowrap">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        if (!link.target) {
                          e.preventDefault();
                          navigate(link.href);
                        }
                      }}
                      target={link.target}
                      rel={link.rel}
                      className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2020 - {new Date().getFullYear()} 蘑菇视频 mogu.video 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 cursor-pointer transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}